import { TutorialStep } from "..";

export const TypeClsSteps: TutorialStep[] = [
  {
    target: "#type-cls",
    content: "정제된 데이터셋 생성을 위해 분류 프로젝트를 생성해볼게요.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#material-name",
    content: "자재명을 자유롭게 입력해보세요.",
    spotlightClicks: true,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#next-btn",
    content: "Next 버튼을 눌러 다음 단계로 이동하세요.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#select-dataset-file",
    content: "기존 선택: 서버에 존재하고 있는 기존 데이터셋 파일을 선택합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
